//we use this id for create unic name for multiselect
//only used for the ac selection
var radioUnicId = 0

export function purchase_vs_lost(id) {

    radioUnicId++
    return `

	<div class="line line-${id} " lineId="${id}" id="inventory_form_mt_${radioUnicId}">   

	    <div class="row">
	
            <div class="c25">

                <div class="textfield  textfield-autocomplete textfield-autocomplete-mini textfield-autocomplete-disabled purchase_id" id="inventory_form_purchaseid_mt_${radioUnicId}" selected = '[]'  max = '1'>

                    <input autocomplete="off"  class= 'elem' type="text" 
                        data-detail='{
                        "key": [   {"dest":"textfield",    "act":"typing" }, 
                                    {"dest":"autocomplete", "act":"typing",  "entity": "purchase_vs_inventory", "mainFilter": ["code"], "parent": "inventory_form_purchaseid_mt_${radioUnicId}"   }],
                        "click": [ {"dest":"autocomplete", "act":"click",   "entity": "purchase_vs_inventory", "mainFilter": ["code"], "parent": "inventory_form_purchaseid_mt_${radioUnicId}"   }]
                        }' tabindex="-1" readonly>
                        
                    <div class="chip-cont"></div>
                    <!-- otherField is used for autocomplete other fields, different than id and displayText -->  
                    <div class="dn otherField" data-detail='{}' ></div>

                </div> <!-- textfield --> 

            </div><!-- c16 --> 
            
            <div class="c16">

                <div class="textfield  textfield-mini textfield-disabled po_qty "  >

                    <input autocomplete="off"  class= 'elem' type="text"  placeholder="" tabindex="-1"
                    data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

                </div><!-- textfield -->  

            </div><!-- c16 --> 

            <div class="c16">

                <div class="textfield  textfield-mini textfield-disabled available "  >

                    <input autocomplete="off"  class= 'elem' type="text"  placeholder="" tabindex="-1"
                    data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

                </div><!-- textfield -->  

            </div><!-- c16 --> 
    
            <div class="c16">
                <div class="textfield textfield-date  textfield-desk  textfield-mini lost_date"  >
                    <input autocomplete="off"  class= 'elem' type="date"   value = ''
                            data-detail='{"click": [ {"dest":"textfield", "act":"focused"  }], 
                                            "key": [ {"dest":"textfield", "act":"typing"  }, 
                                        {"dest":"textfield", "act":"validator", "validator": "date"  }],
                                            "change": [{"dest":"textfield", "act":"validator", "validator": "date"  }] }'  >

                    <div class="indicador"></div>
                    <div class="label"></div> 
                </div><!-- textfield -->  
            </div>

            <div class="c16">

                <div class="textfield  textfield-mini  lost_qty "  >

                    <input autocomplete="off"  class= 'elem' type="number"  placeholder=""  step="1" min="0" 
                    data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  },
                    	                     {"dest":"inventory", "elem":"fullcont",  "act":"processQtyItemLost"}] }' >

                </div><!-- textfield -->  

            </div><!-- c16 --> 

            <div class="dn">

                <div class="textfield  textfield-mini  purchase_vs_itemId"  >

                    <input autocomplete="off"  class= 'elem' type="text"  placeholder="" 
                    data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>

                </div><!-- textfield -->  

            </div><!-- c16 --> 

	    </div><!-- row -->

	</div><!-- line -->  
	`

}


